var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"sortWrapper"},[_c('i',{class:{
    sortup: true,
    active:
      _vm.sortBy === _vm.sortField
      && _vm.sortDir === 1,
  }}),_c('i',{class:{
    sortdown: true,
    active:
      _vm.sortBy === _vm.sortField
      && _vm.sortDir === 0,
  }})])}
var staticRenderFns = []

export { render, staticRenderFns }